import Loadable from 'react-loadable'

export default Loadable({
  loader: () => import(/* webpackChunkName: "signup" */ './index'),
  loading: () => null,
})
